// components/menuItem/MenuItem.jsx
import React from "react";
import { useSelector } from "react-redux";

const MenuItemFresha = ({ item, onClick, isSelected }) => {
  const cart = useSelector((state) => state.cart.cart);
  const cartItem = cart.find((cartItem) => cartItem._id === item._id);
  const itemCountInCart = cartItem ? cartItem.count : 0;
  const isItemInCart = itemCountInCart > 0;

  return (
    <div
      onClick={onClick}
      className={`relative w-full flex justify-between items-center gap-4 p-4 border border-border rounded-lg transition-all cursor-pointer
        ${
          isItemInCart
            ? "border-reddark bg-redlight"
            : "border-border hover:bg-gray-200 dark:bg-neutral-800"
        }`}
    >
      <div className="flex-1 sm:pr-4">
        <p
          className={`text-base sm:text-md font-semibold ${
            isItemInCart ? "text-reddark" : ""
          }`}
        >
          {item.title}
        </p>
        <p
          className={`text-sm  ${
            isItemInCart ? "text-reddark" : "text-textGray"
          }`}
        >
          {item.desc || " "}
        </p>
        <p className="text-base text-text text-sm mt-1">
          ${item.price}
          {item.discount && (
            <span className="text-green-600 text-sm font-semibold ml-2">
              Save {item.discount}
            </span>
          )}
        </p>
        {isItemInCart && (
          <div className="absolute top-0 right-0 w-6 h-6 bg-reddark border border-border text-white text-xs font-semibold rounded-tr-lg flex items-center justify-center">
            {itemCountInCart}
          </div>
        )}
      </div>

      <div className="mt-1">
        {isItemInCart ? (
          <div className="w-6 h-6 bg-reddark rounded-md flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        ) : (
          <div className="w-6 h-6 border border-textGray rounded-md" />
        )}
      </div>
    </div>
  );
};

export default MenuItemFresha;
